import apiRequest from 'shared/services/api';
import {
  PATH, FORM_KEYS, APPLICANT_HISTORY_CODE, STORAGE_KEY, IS_LOGOUT,
} from 'shared/constant';
import { applicantAction, personalInformation } from 'shared/store/actions';
import { ACTION_TYPE } from './actionTypes';
import stepAction from './steps';

const { AUTH } = ACTION_TYPE;

// const updatePhoneNumber = phoneNumber => ({
//   type: AUTH.UPDATE_PHONE_NUMBER,
//   payload: { phoneNumber },
// });

const saveDsUserDetail = payload => ({
  type: AUTH.SAVE_DS_USER_DETAIL,
  payload,
});

const updatePhoneNumber = phoneNumber => (dispatch) => {
  dispatch({
    type: AUTH.UPDATE_PHONE_NUMBER,
    payload: { phoneNumber },
  });

  // save mobile number on the store
  dispatch(personalInformation.updateClientDetails(FORM_KEYS.CLIENT_DETAILS.MOBILE, phoneNumber));
};

const updateEmailAddress = payload => ({
  type: AUTH.UPDATE_EMAIL_ADDRESS,
  payload,
});

const requestOtpSuccess = () => ({
  type: AUTH.REQUEST_OTP_SUCCESS,
});

const verifyOtpSuccess = token => ({
  type: AUTH.VERIFY_OTP_SUCCESS,
  payload: { token },
});

const authFail = error => ({
  type: AUTH.AUTH_FAIL,
  payload: { error },
});

const validateTokenSuccess = (isAuthenticated) => {
  const date = new Date();
  return {
    type: AUTH.VALIDATE_TOKEN_SUCCESS,
    payload: { isAuthenticated, otpTime: date.getTime() },
  };
};

/**
 * Validate user token (isUserAuthenticated)
 */
const validateUserToken = () => async (dispatch, getState) => {
  const { token } = getState().authReducer;
  try {
    const res = await apiRequest.validateToken(token);
    await dispatch(validateTokenSuccess(res));
  } catch (error) {
    localStorage.removeItem(STORAGE_KEY.CURRENT_IP_DATA);
    await dispatch(authFail(error));
    // window.location.replace('/');
    // When user expried token will be get new refCode
    await dispatch(applicantAction.saveLatestRefCode(IS_LOGOUT));
    const { PUBLIC_URL } = process.env;
    window.location.replace(PUBLIC_URL);
  }
};

const onUpdateIsUserExisting = payload => ({
  type: AUTH.UPDATE_IS_USER_EXISTING,
  payload,
});

/**
 * Request OTP on the back
 */
const requestOTP = (isEmail = false, captchaToken) => async (dispatch, getState) => {
  const { phoneNumber, emailAddress } = getState().authReducer;
  // const userInput = isEmail ? emailAddress : phoneNumber;
  try {
    const res = await apiRequest.requestOTP(phoneNumber, emailAddress, isEmail, captchaToken);
    if (res) {
      dispatch(requestOtpSuccess());
      dispatch(onUpdateIsUserExisting(res.existingUser));
      return res;
    }
  } catch (error) {
    await dispatch(authFail(error));
  }
};

/**
 * Verify OTP code
 */
const verifyOTP = (otp, history, isEmailOtp = false, tokenCaptcha, otpType) => async (dispatch, getState) => {
  const {
    authReducer: { phoneNumber, emailAddress },
    // applicantRootReducer: { applicantReducer: { applicantId } }
  } = getState();
  // const userInput = phoneNumber !== '' ? phoneNumber : emailAddress;
  const withRefProductCode = history.location?.state?.withRefProductCode !== undefined ? history.location?.state?.withRefProductCode : false;
  try {
    const res = await apiRequest.verifyOTP(phoneNumber, otp, emailAddress, tokenCaptcha, otpType);
    if (res && res.token) {
      const ip = await apiRequest.getIpAddress();

      localStorage.setItem(STORAGE_KEY.CURRENT_IP_DATA, ip);
    }
    Promise.all([
      await dispatch(verifyOtpSuccess(res.token)),
      await dispatch(validateUserToken(res.token)),
      await dispatch(applicantAction.createApplicant()),
    ]).then(() => {
      dispatch(applicantAction.getApplicantDetails(withRefProductCode));

      dispatch(stepAction.updateCurrentStep('step2'));

      if (!isEmailOtp) dispatch(applicantAction.updateHistory(APPLICANT_HISTORY_CODE.VERIFY_OTP.code, APPLICANT_HISTORY_CODE.VERIFY_OTP.codeI18n));
      else dispatch(applicantAction.updateHistory(APPLICANT_HISTORY_CODE.VERIFY_OTP_EMAIL.code, APPLICANT_HISTORY_CODE.VERIFY_OTP_EMAIL.codeI18n));

      history.push(PATH.AUTH_SUCCESS);
    });
  } catch (error) {
    await dispatch(authFail(error));
  }
};

const logout = () => async (dispatch, getState) => {
  const {
    authReducer: { token },
  } = getState();
  try {
    await apiRequest.requestLogout(token);
    localStorage.removeItem(STORAGE_KEY.CURRENT_IP_DATA);

    // if (res) {
    await dispatch({ type: AUTH.LOGOUT });
    //* * Reset refCode = current refCode */
    await dispatch(applicantAction.saveLatestRefCode(IS_LOGOUT));
    // }
  } catch (error) {
    await dispatch(authFail(error));
  }
};

const authAction = {
  updatePhoneNumber,
  updateEmailAddress,
  requestOTP,
  verifyOTP,
  validateUserToken,
  logout,
  saveDsUserDetail,
};

export default authAction;
